import type {ReactElement} from 'react';
import React, {useEffect, useState} from 'react';
import {DigitalSignageSubPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/digital-signage-sub-panel/digital-signage-sub-panel';
import {setErrorMessageForPublishing, setErrorOnPublishPanel} from '@Panels/poster-publishing-options-panel/poster-publishing-options-slice';
import {useAppDispatch} from '@/hooks';
import type {PublishingSmartTvPanelProps} from './publishing-smart-tv-panel.types';
import {useProductUsed} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel-library';
import {useCopyButton} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/publishing-digital-signage-list.hooks';
import {noop} from '@Utils/general.util';
import {usePosterPageHashedId} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.hooks';

export function PublishingSmartTvPanel({...props}: PublishingSmartTvPanelProps): ReactElement<any> {
  const [displayCode, setDisplayCode] = useState('');
  const [copied, setCopied] = useState(false);
  const dispatch = useAppDispatch();
  const productUsed = useProductUsed();
  const pageHashedId = usePosterPageHashedId();
  const pageOrderId = productUsed?.existingPageOrders?.[pageHashedId] ?? productUsed?.orderId;

  useEffect(() => {
    try {
      if (pageOrderId != null && pageOrderId !== '') {
        void window.PMW.readLocal('v/generateDisplayCode', {
          orderId: pageOrderId,
        })
          .then((response: string) => {
            setDisplayCode(response);
          })
          .catch(() => {
            dispatch(setErrorOnPublishPanel(true));
            dispatch(setErrorMessageForPublishing(window.i18next.t('pmwjs_error_message')));
          });
      }
    } catch (e) {
      console.error(e);

      dispatch(setErrorOnPublishPanel(true));
      dispatch(setErrorMessageForPublishing(window.i18next.t('pmwjs_error_message')));
    }
  }, [pageOrderId]);

  return (
    <DigitalSignageSubPanel
      panelHeading={window.i18next.t('pmwjs_smart_tv')}
      heading={window.i18next.t('pmwjs_play_on_smart_tv')}
      subheading={window.i18next.t('pmwjs_play_on_smart_tv_desc')}
      showInputBar
      onClose={props.onClose}
      inputBarIcon="icon-link"
      webpageLink={window.PMW.util.site_url(`v/d/${displayCode}`)}
      showButton
      buttonComponent={useCopyButton(copied, window.PMW.util.site_url(`v/d/${displayCode}`), setCopied, noop)}
    />
  );
}
